<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">

        
        
        <Detail 
          :header="'User Details'" 
          :values="values" 
          @edit="edit"
        />
        <TabMenu :model="nestedRouteItems" />
        <router-view v-if="user" :user="user" />

      </div>
    </div>
    
    <UserForm
      :userForm="userFormDialog"
      :reloadForm="reloadUserForm"
      :disabledArr="['email']"
      :userToEdit="user"
      @close="userFormDialog = false"
      @updated="updated"
    />
  </div>
</template>

<script>
import UserService from "@/service/UserService";
import Detail from "@/mbp/universalComponents/Detail.vue";
import UserForm from '@/mbp/universalComponents/user/UserForm'
import BreadcrumbRecordMixin from '../BreadcrumbRecordMixin'

export default {
  mixins: [BreadcrumbRecordMixin],
  created() {
    this.getUserInfo()
  },
  computed: {
    breadcrumbRecordLabel() {
      if (!this.user) return ''
      return [this.user.firstName, this.user.lastName].filter(Boolean).join(' ')
    }
  },
  components: {
    Detail,
    UserForm
  },
  data() {
    return {
      userService: new UserService(),
      nestedRouteItems: [
        {
          label: "Details",
          icon: 'pi pi-info-circle',
          to: `/users/${this.$route.params.userid}/detail`,
        },
        {
          label: "Login History",
          icon: 'pi pi-inbox',
          to: `/users/${this.$route.params.userid}/history`,
        },
        {
          label: "Dashboard",
          icon: 'pi pi-desktop',
          to: `/users/${this.$route.params.userid}/dashboard`,
        },
        {
          label: "Widgets",
          icon: 'pi pi-th-large',
          to: `/users/${this.$route.params.userid}/widgets`,
        }
      ],
      user: {},
      values: [],
      userFormDialog: false,
      reloadUserForm: 0,
    };
  },
  methods: {
    getUserInfo() {
      // 

      this.userService
        .getUserById(this.$route.params.userid)
        .then(data => {
            this.user = data

          this.values = [
            {
              title: "email:",
              description: this.user ? this.user.email : "",
            },
            {
              title: "Name:",
              description: this.user ? this.user.firstName + this.user.lastName : "",
            },
            {
              title: "Status:",
              description: this.user ? this.user.status : "",
            },
            null
          ]
        })
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting user info",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "userInfo"'
          })
        })
    },
    updated(user) {
      
      this.userFormDialog = false

      this.getUserInfo()

      this.$toast.add({
        severity: "success",
        summary: "Success",
        detail: "User updated successfully",
        life: 5000,
      });
    },
    edit() {
      this.userFormDialog = true
      this.reloadUserForm++
    }
  }
}
</script>

<style>

</style>